/* ==========================================
   Fast Lane Drive — Wholesale helpers
   Scope: /apps/wpdapp/wholesale/*
   ========================================== */

(function () {
  const PATH_ROOT = '/apps/wpdapp/wholesale';
  if (!location.pathname.startsWith(PATH_ROOT)) return;

  console.log('[wholesale] helpers active');

  /* =========================================================
     SECTION 1 — PREORDER LABEL SWAP (KEEP)
     - Finds specific product cards by data-product-handle
     - Replaces the button label text with "PREORDER"
     - Uses MutationObserver to persist through app re-renders
     ========================================================= */

  const PREORDER_HANDLES = [
    'fast-lane-drive-signature-gold-pen',
    'fast-lane-drive-insulated-water-rambler',
    'fast-lane-drive-signature-luggage-tag',
    'fast-lane-drive-unisex-bathrobe',
    'fast-lane-drive-double-wall-glass-tea-infuser',
    'fast-lane-drive-mens-sponsors-jacket',
    'fast-lane-drive-womens-sponsors-jacket'
  ];

  function updatePreorderLabels(scope) {
    PREORDER_HANDLES.forEach(function (handle) {
      const card = scope.querySelector(`.wpd-grid-item[data-product-handle="${handle}"]`);
      if (!card) return;

      const label = card.querySelector('.loader-button-label');
      if (!label) return;

      if (label.textContent.trim() !== 'PREORDER') {
        label.textContent = 'PREORDER';
        label.classList.add('wpd-preorder-label');
      }
    });
  }

  // First pass
  updatePreorderLabels(document);

  // Observe app re-renders so preorder labels stay correct
  const domObserver = new MutationObserver(function () {
    updatePreorderLabels(document);
  });

  domObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  /* =========================================================
     SECTION 2 — WHOLESALE CART OVERRIDES (COMMENTED OUT)
     Original intent:
     - Force native checkout (bypass app handler)
     - Block /cart/clear so the app cannot clear the cart
     - Re-wire checkout button clicks
     NOTE:
     - Keep disabled unless you confirm a cart/checkout issue.
     ========================================================= */

  
  if (location.pathname.includes('/wpd-cart')) {
    console.log('[wholesale] cart page fix active');

    // Block /cart/clear.* via fetch
    const origFetch = window.fetch;
    window.fetch = function (input, init) {
      const url = (typeof input === 'string') ? input : (input && input.url) || '';
      if (url && url.indexOf('/cart/clear') !== -1) {
        console.warn('[wholesale] blocked fetch:', url);
        return Promise.resolve(new Response('{}', {
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        }));
      }
      return origFetch.apply(this, arguments);
    };

    // Block /cart/clear.* via XHR
    const XHR   = window.XMLHttpRequest;
    const _open = XHR.prototype.open;
    const _send = XHR.prototype.send;

    XHR.prototype.open = function (method, url) {
      this.__url = url;
      return _open.apply(this, arguments);
    };

    XHR.prototype.send = function (body) {
      if ((this.__url || '').indexOf('/cart/clear') !== -1) {
        console.warn('[wholesale] blocked XHR:', this.__url);
        try {
          this.readyState   = 4;
          this.status       = 200;
          this.responseText = '{}';
          this.response     = '{}';
          if (typeof this.onload === 'function') this.onload();
          if (typeof this.onreadystatechange === 'function') this.onreadystatechange();
        } catch (_) {}
        return;
      }
      return _send.apply(this, arguments);
    };

    // Force a native POST checkout (bypass app handler)
    const checkoutForm = document.createElement('form');
    checkoutForm.method = 'post';
    checkoutForm.action = '/cart';

    const hidden = document.createElement('input');
    hidden.type  = 'hidden';
    hidden.name  = 'checkout';
    hidden.value = '1';
    checkoutForm.appendChild(hidden);

    document.addEventListener('DOMContentLoaded', function () {
      document.body.appendChild(checkoutForm);
    });

    function gotoCheckout(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      checkoutForm.submit();
    }

    const checkoutSelectors = [
      '[data-wpd-checkout]',
      '.wpd-checkout',
      'button[name="checkout"]',
      'a[href="/checkout"]',
      '.btn-checkout',
      '.checkout'
    ].join(',');

    function wireCheckout() {
      document.querySelectorAll(checkoutSelectors).forEach(function (el) {
        if (!el.__wholesalePatched) {
          el.addEventListener('click', gotoCheckout, true);
          el.__wholesalePatched = true;
        }
      });
    }

    wireCheckout();

    new MutationObserver(wireCheckout).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
  
})();
